// 只用一次不迁移
export const ChannelSubscribe = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.66125 4.25023C7.22427 1.75772 10.7757 1.75772 11.3388 4.25023C13.4993 2.88587 16.0106 5.39714 14.6462 7.55773C17.1388 8.12075 17.1388 11.6722 14.6462 12.2352C16.0106 14.3958 13.4993 16.9071 11.3388 15.5427C10.7757 18.0353 7.22427 18.0353 6.66125 15.5427C4.50065 16.9071 1.98939 14.3958 3.35375 12.2352C0.861233 11.6722 0.861233 8.12075 3.35375 7.55773C1.98939 5.39714 4.50066 2.88587 6.66125 4.25023Z"
      fill="#249AE1"
    />
    <path
      d="M6.08398 9.89681L8.16732 11.9801L12.334 7.81348"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);
